import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { lazy, Suspense } from "react";
import { useAuth } from "./auth";
import { LoadingState, PlatformLayout } from "./components";

const LoginPage = lazy(() => import("./pages/LoginPage"));
const OverviewPage = lazy(() => import("./pages/OverviewPage"));
const TenantsPage = lazy(() => import("./pages/TenantsPage"));
const InvitationsPage = lazy(() => import("./pages/InvitationsPage"));
const TenantDetailPage = lazy(() => import("./pages/TenantDetailPage"));
const BusinessPage = lazy(() => import("./pages/BusinessPage"));
const AutomationsPage = lazy(() => import("./pages/AutomationsPage"));
const HealthPage = lazy(() => import("./pages/HealthPage"));
const OperatorsPage = lazy(() => import("./pages/OperatorsPage"));
const VehiclesPage = lazy(() => import("./pages/VehiclesPage"));
const EventsPage = lazy(() => import("./pages/EventsPage"));
const SecurityPage = lazy(() => import("./pages/SecurityPage"));

function ProtectedPlatform() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <LoadingState label="Verificando acceso de plataforma…" />;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return <PlatformLayout><Outlet /></PlatformLayout>;
}

export default function App() {
  return <Suspense fallback={<LoadingState />}><Routes>
    <Route path="/login" element={<LoginPage />} />
    <Route element={<ProtectedPlatform />}>
      <Route index element={<OverviewPage />} />
      <Route path="concesionarios" element={<TenantsPage />} />
      <Route path="invitaciones" element={<InvitationsPage />} />
      <Route path="concesionarios/:tenantId" element={<TenantDetailPage />} />
      <Route path="vehiculos" element={<VehiclesPage />} />
      <Route path="eventos" element={<EventsPage />} />
      <Route path="negocio" element={<BusinessPage />} />
      <Route path="equipo-cochegest" element={<OperatorsPage />} />
      <Route path="seguridad" element={<SecurityPage />} />
      <Route path="automatizaciones" element={<AutomationsPage />} />
      <Route path="salud" element={<HealthPage />} />
    </Route>
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes></Suspense>;
}
